import React from "react";

/* Renderer de markdown mínim per als plans APPCC:
   ### títols · > avisos · taules amb | · llistes amb - · paràgrafs. */
export default function Markdown({ text }) {
  if (!text) return null;
  const blocks = splitBlocks(text);
  return (
    <div className="space-y-4">
      {blocks.map((b, i) => <Block key={i} block={b} />)}
    </div>
  );
}

function splitBlocks(text) {
  const lines = text.split("\n");
  const blocks = [];
  let cur = null;
  const flush = () => { if (cur) { blocks.push(cur); cur = null; } };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); continue; }
    if (line.startsWith("|")) {
      if (cur?.type !== "table") { flush(); cur = { type: "table", rows: [] }; }
      cur.rows.push(line);
    } else if (line.startsWith("### ")) {
      flush(); blocks.push({ type: "h3", text: line.slice(4) });
    } else if (line.startsWith("## ")) {
      flush(); blocks.push({ type: "h3", text: line.slice(3) });
    } else if (line.startsWith("> ")) {
      flush(); blocks.push({ type: "quote", text: line.slice(2) });
    } else if (line.startsWith("- ")) {
      if (cur?.type !== "list") { flush(); cur = { type: "list", items: [] }; }
      cur.items.push(line.slice(2));
    } else {
      if (cur?.type !== "p") { flush(); cur = { type: "p", parts: [] }; }
      cur.parts.push(line);
    }
  }
  flush();
  return blocks;
}

function Block({ block }) {
  switch (block.type) {
    case "h3":
      return <h3 className="pt-2 font-display text-lg font-bold text-terracotta">{block.text}</h3>;
    case "quote": {
      const danger = block.text.startsWith("⛔");
      return (
        <div className={"rounded-xl border p-3 text-sm leading-relaxed " +
          (danger ? "border-ember/30 bg-ember-bg text-ember" : "border-terracotta/30 bg-terracotta/5 text-ink")}>
          {block.text}
        </div>
      );
    }
    case "list":
      return (
        <ul className="space-y-1 pl-1 text-sm leading-relaxed text-ink">
          {block.items.map((it, i) => (
            <li key={i} className="flex gap-2"><span className="text-terracotta">•</span><span>{it}</span></li>
          ))}
        </ul>
      );
    case "table": {
      const parse = (l) => l.replace(/^\|/, "").replace(/\|$/, "").split("|").map((c) => c.trim());
      const rows = block.rows.filter((r) => !/^\|[\s\-|]+\|$/.test(r)).map(parse);
      if (rows.length === 0) return null;
      const [head, ...body] = rows;
      return (
        <div className="overflow-x-auto rounded-xl border border-line">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-cream/60">
                {head.map((c, i) => <th key={i} className="whitespace-nowrap px-3 py-2 text-left font-semibold text-ink">{c}</th>)}
              </tr>
            </thead>
            <tbody>
              {body.map((r, ri) => (
                <tr key={ri} className="border-t border-line">
                  {r.map((c, ci) => <td key={ci} className="px-3 py-2 align-top text-ink-soft first:font-medium first:text-ink">{c}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    default:
      return <p className="text-sm leading-relaxed text-ink">{block.parts.join(" ")}</p>;
  }
}
